import { FleetMode } from '@/enum/FleetMode'
import { IMissionPlan } from '../missionPlan/IMissionPlan'
import { getDefaultFleetIrisConfigBase, IFleetIrisConfigBase } from './IFleetIrisConfigBase'
import { MissionPlanUiState } from '@/models/ui/MissionPlanUiState'
import { IGliderFleetFormationConfig } from './IGliderFleetFormationConfig'

export interface IFleetIrisConfigFormation extends IFleetIrisConfigBase {
  glider_association: Record<string, [string | null, number | null, [number, number]]>
  deadzone_formation: number
  deadzone_alarm: number
  deadzone_cycle: number
  deadzone_trackFollow: number
  gliders_config: Record<string, IGliderFleetFormationConfig>
  barycentre_mission_plan: IMissionPlan
}

export function getDefaultFleetIrisConfigFormation({
  glider_association = {},
  fleet_type = FleetMode.KEEPFORMATION,
  glider_number = 1,
  fleet_company = '',
  fleet_name = '',
  fleet_state = null,
  fleet_state_timestamp = null,
  deadzone_formation = 0.5,
  deadzone_alarm = 1.5,
  deadzone_cycle = 2,
  deadzone_trackFollow = 1,
  gliders_config = {},
  barycentre_mission_plan = MissionPlanUiState.getDefaultMissionPlan(),
} = {}): IFleetIrisConfigFormation {
  return {
    ...getDefaultFleetIrisConfigBase({
      fleet_type,
      glider_number,
      fleet_company,
      fleet_name,
      fleet_state,
      fleet_state_timestamp,
    }),
    glider_association,
    deadzone_formation,
    deadzone_alarm,
    deadzone_cycle,
    deadzone_trackFollow,
    gliders_config,
    barycentre_mission_plan,
  }
}

//retourne une liste de code d'erreur si la configuration n'est pas valide
//si valide pour la simulation le tableau est vide
export function isReadyForIrisFleetFormation(data: IFleetIrisConfigFormation | null): Array<string> {
  const errorCode = [] as Array<string>

  if (!data?.barycentre_mission_plan?.steps?.length) errorCode.push('MissingSteps')
  if (!((data?.barycentre_mission_plan?.cur_step ?? -1) > -1)) errorCode.push('MissingCurrentStep')
  else if (data?.barycentre_mission_plan.steps.findIndex(s => s.id == data?.barycentre_mission_plan?.cur_step) == -1)
    errorCode.push('MissingCurrentStep')
  if (data?.barycentre_mission_plan?.steps?.some(s => !((s?.prfNav_id ?? -1) > -1)))
    errorCode.push('MissingProfilNavOnStep')
  if (
    !data?.glider_association ||
    Object.keys(data.glider_association).some(
      k =>
        data?.glider_association[k]?.at(0) == null ||
        data?.glider_association[k]?.at(1) == null ||
        data?.glider_association[k]?.at(2) == null,
    )
  )
    errorCode.push('MissingGliderAssociation')

  //verification des deadzones
  if (data && data?.deadzone_alarm < data?.deadzone_formation) errorCode.push('InvalidDeadzoneAlarm')

  return errorCode
}
